import axios from 'axios';

export default axios.create({
    baseURL: 'https://yoga-andrea.ca/api'
});